import React from "react";
import Profile from "../components/Profile/Profile";
export default function ProfilePage() {
  return (
    <div className="page-layout">
      <Profile />
    </div>
  );
}
